export default "/images/d909d53cce16b65f72777c88f874101b.avif";